import React from "react";

const Calendar = ({ className }) => {
  return (
    <svg
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M7.46733 0.485858C7.43556 0.212322 7.20309 0 6.92103 0C6.61727 0 6.37103 0.246243 6.37103 0.55V1.09998H3.62175V0.55L3.61804 0.485858C3.58627 0.212322 3.3538 0 3.07174 0C2.76799 0 2.52174 0.246243 2.52174 0.55V1.09998H2.30156C1.08654 1.09998 0.101562 2.08495 0.101562 3.29998V8.79998C0.101562 10.015 1.08654 11 2.30156 11H7.80156C9.01659 11 10.0016 10.015 10.0016 8.79998V3.29998C10.0016 2.08495 9.01659 1.09998 7.80156 1.09998H7.47103V0.55L7.46733 0.485858ZM2.52174 2.2V2.19997H2.30204C1.69453 2.19997 1.20204 2.69246 1.20204 3.29997V3.57499H8.90204V3.29997C8.90204 2.69246 8.40955 2.19997 7.80204 2.19997H7.47103V2.2C7.47103 2.50376 7.22479 2.75 6.92103 2.75C6.63897 2.75 6.4065 2.53768 6.37473 2.26414L6.37103 2.2V2.19997H3.62175V2.2C3.62175 2.50376 3.3755 2.75 3.07174 2.75C2.78969 2.75 2.55722 2.53768 2.52545 2.26414L2.52174 2.2ZM8.90204 4.67498H1.20204V8.79997C1.20204 9.40748 1.69453 9.89997 2.30204 9.89997H7.80204C8.40955 9.89997 8.90204 9.40748 8.90204 8.79997V4.67498Z" fill="currentColor" />
    </svg>
  );
};

export default Calendar;

